// Styles for List/Show/Create/Edit elements

import FuseTheme from '../global/theme';

export const viewStyles = {
    actions: {zIndex: 2, display: 'inline-block', float: 'right'},
    avatar: {
        backgroundColor: '#6e6e6e',
        width: 40,
        height: 40,
        marginRight: 10,
        verticalAlign: 'bottom',
    },
    break: {
        display: 'block',
        width: '100%',
        height: 0,
        border: 'none',
        margin: 0,
    },
    noWrap: {
        whiteSpace: 'nowrap'
    },
    calendarInput: {
        border: 'none',
        borderBottom: '1px solid rgba(33, 33, 33, 0.1)',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: 16,
        textTransform: 'uppercase',
        width: '100%',
        outline: 'none',
        padding: '3px 0 3px 0',
    },
    calendarTopMargin: {
        marginTop: 15
    },
    calendarInputLabel: {
        color: 'rgba(33, 33, 33, 0.3)',
        fontSize: 12,
    },
    diagram: {
        display: 'block',
        width: 'auto',
        maxWidth: '100%',
        height: 'auto',
        margin: 0,
    },
    diagramRight: {
        display: 'inline-block',
        float: 'right',
        width: '200px',
        maxWidth: '100%',
        height: 'auto',
        margin: '0 0 0.5em 1em',
        clear: 'right',
    },
    diagramSmall: {
        display: 'inline-block',
        float: 'right',
        width: '200px',
        maxWidth: '100%',
        height: 'auto',
        margin: '0 0 1em 1em',
    },
    divider: {
        display: 'block',
        width: '100%',
        height: 1,
        backgroundColor: '#1478b9',
        border: 'none',
        margin: '1em 0 0.5em 0',
    },
    error: {
        color: FuseTheme.palette.accent1Color,
    },
    fieldDescription: {
        flex: '1 1 40%',
        display: 'inline-block',
        width: 'auto',
        height: '2em',
        fontSize: '12px',
        color: 'rgba(33,33,33,0.5)',
        verticalAlign: 'bottom',
    },
    fieldDescriptionTop: {
        display: 'block',
        width: 'auto',
        fontSize: '14px',
        color: 'rgba(33,33,33,0.5)',
        margin: 0,
        verticalAlign: 'bottom',
    },
    fieldTitle: {
        display: 'block',
        width: '100%',
        fontSize: '20px',
        fontWeight: '500',
        color: 'rgba(33,33,33,0.5)',
        margin: '1em 0 1em 0',
    },
    fieldHeader: {
        display: 'block',
        width: '100%',
        fontSize: '16px',
        fontWeight: 'bold',
        color: 'rgba(33,33,33,0.5)',
        margin: '2em 0 0 0',
    },
    fieldHeaderDescription: {
        fontSize: '12px',
        fontWeight: 'normal',
    },
    fieldInput: {
        display: 'block',
        width: '100%',
        fontSize: '14px',
        color: 'rgba(33,33,33,0.8)',
        margin: '0 0 2em 0',
    },
    fieldInstructions: {
        display: 'block',
        width: '100%',
        fontSize: '14px',
        fontWeight: 'bold',
        color: 'rgba(33,33,33,0.5)',
        margin: '2em 0 2em 0',
    },
    fieldLabel: {
        display: 'block',
        fontSize: '14px',
        color: 'rgba(33,33,33,0.5)',
        margin: '0 0 4px 0',
        verticalAlign: 'bottom',
    },
    fieldParagraph: {
        display: 'block',
        width: '100%',
        fontSize: '14px',
        color: 'rgba(33,33,33,0.5)',
        margin: '0 0 2em 0',
    },
    fieldLight: {color: 'rgba(0, 0, 0, 0.3)'},
    fieldMediumColor: {color: 'rgba(33,33,33,0.5)'},
    fieldLink: {
        color: '#1478b9',
        textDecoration: 'none',
        borderBottom: '1px dotted rgba(33,33,33,0.5)',
    },
    fieldMultiline: {
        fontSize: '14px',
        padding: '4px 4px 4px 2px',
    },
    fieldSubheader: {
        display: 'block',
        width: '100%',
        fontSize: '14px',
        fontWeight: 'bold',
        color: 'rgba(33,33,33,0.5)',
        margin: '1em 0 0 0',
    },
    fieldFull: {
        display: 'block',
        width: '100%',
        margin: 0
    },
    fieldWide: {
        flex: '0 1 80%',
        display: 'block',
        minWidth: '80%',
        maxWidth: '100%',
        overflow: 'hidden',
    },
    fieldWrap: {
        whiteSpace: 'pre-wrap',
    },
    scopeWrap: {
        display: 'inline-block',
        maxWidth: '50vw',
        overflowWrap: 'break-word'
    },
    filterDescription: {
        display: 'block',
        width: 'auto',
        height: '2em',
        fontSize: '16px',
        color: 'rgba(33,33,33,0.5)',
        margin: '1em 0 0 16px',
    },
    filterFull: {
        display: 'block',
        width: '100%',
        margin: 0
    },
    filterThreeQuarters: {minWidth: '75%'},
    filterHalf: {minWidth: '50%'},
    filterInline: {display: 'inline-block', fontSize: '16px', marginRight: 10},
    filterLeft: {fontSize: '16px', width: '100%', minWidth: '50%'},
    filterSelectSmall: {
        display: 'inline-block',
        width: 155,
        minWidth: 50,
        maxWidth: 155,
        marginTop: 0,
        marginRight: '1em',
        overflow: 'hidden',
    },
    filterDateSelect: {
        display: 'inline-block',
        width: 155,
        minWidth: 50,
        maxWidth: 155,
        marginTop: 15,
        marginRight: '1em',
        overflow: 'hidden',
    },
    filterThird: {minWidth: '33%'},
    filterSearch: {width: 285},
    filterButton: {marginLeft: 10},
    filterLoading: {marginLeft: 4, top: 7},
    headerButton: {
        display: 'inline-block',
        color: '#ffffff',
        margin: '0 10px 0 0',
    },
    headerButtonIcon: {
        display: 'inline-block',
        color: '#ffffff',
        margin: '0 6px 0 8px',
        verticalAlign: 'middle',
    },
    headerButtonLink: {
        display: 'inline-block',
        fontWeight: 500,
        color: '#ffffff',
        textTransform: 'uppercase',
        textDecoration: 'none',
        margin: '0 12px 0 0'
    },
    hidden: {display: 'none'},
    marginBottom: {marginBottom: '1em'},
    marginLeft: {marginLeft: '1em'},
    marginRight: {marginRight: '1em'},
    marginTop: {marginTop: '1em'},
    noMargin: {margin: 0},
    noPaddingTop: {paddingTop: 0},
    paddingBottom: {paddingBottom: '1em'},
    row: {display: 'flex', justifyContent: 'space-between'},
    rowField: {
        flex: '0 1 30%',
        display: 'inline-block',
        margin: '0 1em 0 0',
        verticalAlign: 'top',
    },
    rowShowField: {
        display: 'inline-block',
        width: 'auto',
        minWidth: 100,
        margin: '0 1em 0 0',
        verticalAlign: 'top',
    },
    rowShowFieldWide: {
        display: 'inline-block',
        width: 'auto',
        minWidth: 200,
        margin: '0 1em 0 0',
        verticalAlign: 'top',
    },
    selectInputSmall: {
        minWidth: 50,
        maxWidth: 150,
        marginTop: 0,
        marginRight: '1em',
    },
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/styles-view.js